import React from 'react';
import { Hidden } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { PlanSummaryDto } from '../institution-model';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { PageContainer } from '../../../../../global/components/layout/page-container';
import { MainContent } from '../../../../../global/components/layout/main-content-container';
import { SearchApp } from '../../../../../search/components/search-app';
import { sortTableStyles } from '../../../../../global/constants/theme/styles/tables/generic-sort-table';
import { SearchList } from '../../../../../search/components/search-list';
import { ListPagination } from '../../../../../search/components/list-pagination';
import { InstitutionProps, SearchProps } from '../../../models/arc-epi-props';
import { DbPlanHistoryLabels } from './db-plan-history-label';
import { DbPlanHistoryItemView } from './db-plan-history-item';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';

interface Props {
	planHistory: PlanSummaryDto[];
	searchId: string;
	planName: string;
}

function DbPlanHistory(props: Props) {

	const { planHistory, searchId, planName } = props;
	const settings = useSelector<TcsmStates, InstitutionProps>(state => state.epiProps?.institutionSettingsState?.epiContent);
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps?.searchSettingsState?.epiContent);
	const tableClasses = sortTableStyles();


	return (

		<PageContainer>
			<MainContent fullWidth>
				<PageHeader
					headerText={settings?.planHistoryTitle}
				/>
				<ContentSpacer>
					<h3>{planName}</h3>
				</ContentSpacer>
				<SearchApp initialList={planHistory} appName={searchId} >

					<div className={tableClasses.sortTable}>
						<Hidden xsDown>
							<DbPlanHistoryLabels settings={settings} />
						</Hidden>
						<div className='sort-table-content'>
							<SearchList
								renderList={
									(item) => {
										return <DbPlanHistoryItemView item={item} settings={settings} />;
									}
								}
								renderPagination={
									(totalCounts, name) => {
										return <ListPagination name={name} totalCounts={totalCounts} totalPages={Math.ceil(totalCounts / 10)} nextButton={searchSettings?.nextButton} prevButton={searchSettings?.previousButton} />;
									}
								}
								emptyMessage=''
							/>
						</div>
					</div>
				</SearchApp>
			</MainContent>

		</PageContainer>

	);
}

export default DbPlanHistory;